import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ar from "../../locales/ar.json";
import en from "../../locales/en.json";
import ru from "../../locales/ru.json";

i18n.use(initReactI18next).init({
	fallbackLng: "en",
	supportedLngs: ["en", "ru", "ar"],
	resources: {
		en: {
			translation: en,
		},
		ru: {
			translation: ru,
		},
		ar: {
			translation: ar,
		},
	},
	lng:
		(typeof window !== "undefined" && sessionStorage.getItem("language")) ||
		"en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
